/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2024, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M1.75 5c0-1.795 1.455-3.25 3.25-3.25h7a.75.75 0 0 0 0-1.5H5C2.3767.25.25 2.3767.25 5v14c0 2.6234 2.1267 4.75 4.75 4.75h14c2.6234 0 4.75-2.1266 4.75-4.75v-7a.75.75 0 0 0-1.5 0v7c0 1.7949-1.4551 3.25-3.25 3.25H5c-1.795 0-3.25-1.4551-3.25-3.25V5Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22.6553 1.3447c1.3285 1.3284 1.3285 3.4822 0 4.8106L12.5607 16.25H7.75v-4.8107L17.8447 1.3447c1.3284-1.3284 3.4822-1.3285 4.8106 0Zm-1.0606 1.0606c-.7427-.7426-1.9467-.7426-2.6894 0L9.25 12.0607V14.75h2.6893l9.6554-9.6553c.7426-.7427.7426-1.9467 0-2.6894Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'Edit'
);
